export default __webpack_public_path__ + "static/media/deathSound.df019b66.mp3";